import React from 'react';
import { formatDateParsedZoneLong } from 'platform/utilities/date';

const FULL_DATE = /^\d{4}-\d{2}-\d{2}$/;

const formatReviewDate = value => {
  if (!FULL_DATE.test(value || '')) return value || '';
  // Well-formed but impossible dates (e.g. 2027-13-45) make the formatter throw
  try {
    return formatDateParsedZoneLong(value);
  } catch (e) {
    return value;
  }
};

/**
 * `ui:reviewField` for full-date fields (YYYY-MM-DD) so the review page shows
 * "January 1, 2027" instead of the raw ISO string.
 */
export const reviewDateField = ({ children }) => {
  const { formData, uiSchema } = children.props;
  return (
    <div className="review-row">
      <dt>{uiSchema?.['ui:title']}</dt>
      <dd>{formatReviewDate(formData)}</dd>
    </div>
  );
};
